import Transform from "./Transform.js";

import global from "../global.js";

const d3 = global.d3;

// const log = global.log.getLogger("f_mtac.scene.indicator");

const alpha = Math.PI / 10; // arrow opening angle
const D = 20; // arrow size
const invSQRT2 = 1 / Math.sqrt(2);

const Indicator = function(group) {
    const OX = 100, OY = 100; // transform origin deduced from placer size
    const arrow = d3.create("svg:g").attr("class", "handle");
    const head = arrow.append("polygon")
        .attr("fill", "#000")
        .attr("stroke", "#fff")
        .attr("stroke-width", "0.5");
    this.position = {x: 0, y: 0};
    arrow.node().appendChild(head.node());

    this.init = ({color}) => {
        const CK = 1 / Indicator.transform.state.k;
        const V = invSQRT2 * D * CK;
        const T = Math.tan(alpha) * V;
        const points = [[0, 0], [V - T, V + T], [V + T, V - T]];
        head.attr("fill", color).attr("points", points);
        group.node().appendChild(arrow.node());
    };

    const get_offset = () => {
        const WB = global.app.scale.wb;
        const CK = 1 / Indicator.transform.state.k;
        return {
            x: OX - invSQRT2 * WB * 3 / 2 * CK,
            y: OY - invSQRT2 * WB * 3 / 2 * CK
        };
    };

    this.move_to = function({x, y}) {
        let offset = get_offset();
        this.position.x = x + offset.x;
        this.position.y = y + offset.y;
        arrow.attr("transform", `translate(${this.position.x},${this.position.y})`);
    };

    this.move = function({x, y}) {
        this.position.x += x;
        this.position.y += y;
        arrow.attr("transform", `translate(${this.position.x},${this.position.y})`);
    };

    this.end = () => {
        arrow.remove();
        this.position.x = 0;
        this.position.y = 0;
    };

};

Indicator.transform = new Transform({k: 1});
export default Indicator;
